import { axios } from '@/lib/axios'
import moment from 'moment'

const copyListing = async (
  id: string,
  authInfo: { userId: string; companyId: string },
): Promise<boolean> => {
  const baseUrl = process.env.API_BASE_URL
  try {
    const listingRes = await axios.get(`${baseUrl}/listings/${id}`)
    if (!listingRes.ok) {
      return false
    }
    const { id: originalId, ...listingData } = listingRes.data
    const newListing = {
      ...listingData,
      title: `Copy at ${moment().format('YYYY-MM-DDTHH:mm:ss')} on ${
        listingRes.data.title
      }`,
      company: authInfo.companyId,
    }
    const createdListingResponse = await axios.post(`/listings`, newListing)

    if (!createdListingResponse.ok) {
      return false
    }
    return true
  } catch (e) {
    return false
  }
}

export default copyListing
